import LinearLoader from 'common/components/loaders/linearLoader/LinearLoader'
import Overlay from 'common/components/Overlay'
import { ReactComponent as Logo } from 'common/icons/phraseeLogo/animated.svg'

type Props = {
  isLoading: boolean
}

const LoadingOverlay = ({ isLoading }: Props) => {
  return isLoading ? (
    <Overlay
      bgColor="bg-white"
      type="local"
      className="bg-opacity-100 relative"
    >
      <div className="flex flex-col justify-center items-center text-white text-3xl ">
        <Logo />
        <div className="text-coolGray-900 text-base font-medium mt-4 mb-4">
          Generating Brand tones
        </div>
        <div className="w-82">
          <LinearLoader backgroundColor="transparent" />
        </div>
        <div className="text-coolGray-700 text-base mt-1">
          Preparing your output...
        </div>
      </div>
    </Overlay>
  ) : null
}

export default LoadingOverlay
